<div class="dashboard-card" (click)="openProductUrl()">
  <img class="dashboard-card-image" [alt]="product.name" [src]="product.logoUrl" />
  <h3 class="dashboard-card-title">{{ product.name }}</h3>
</div>
